import i18next, { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import phFeMale1 from "../../../assets/images/blurred2/goal/female/1.png";
import phFeMale2 from "../../../assets/images/blurred2/goal/female/2.png";
import phFeMale3 from "../../../assets/images/blurred2/goal/female/3.png";
import phFeMale4 from "../../../assets/images/blurred2/goal/female/4.png";
import phMale1 from "../../../assets/images/blurred2/goal/male/1.png";
import phMale2 from "../../../assets/images/blurred2/goal/male/2.png";
import phMale3 from "../../../assets/images/blurred2/goal/male/3.png";
import phMale4 from "../../../assets/images/blurred2/goal/male/4.png";
import ImageButton from "../../../components/ImageButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

const preLoadImage = ["/income/1.png", "/income/2.png", "/imoji/thinking.png"];
const buttonText = [
  t("goal_selection.grow_wealth"),
  t("goal_selection.be_boss"),
  t("goal_selection.travel_more"),
  t("goal_selection.other"),
];
const data = {
  male: [
    {
      image: addS3Url("/staging/goal/male/1.png"),
      placeHolderImage: phMale1,
    },
    {
      image: addS3Url("/staging/goal/male/2.png"),
      placeHolderImage: phMale2,
    },
    {
      image: addS3Url("/staging/goal/male/3.png"),
      placeHolderImage: phMale3,
    },
    {
      image: addS3Url("/staging/goal/male/4.png"),
      placeHolderImage: phMale4,
    },
  ],
  female: [
    {
      image: addS3Url("/staging/goal/female/1.png"),
      placeHolderImage: phFeMale1,
    },
    {
      image: addS3Url("/staging/goal/female/2.png"),
      placeHolderImage: phFeMale2,
    },
    {
      image: addS3Url("/staging/goal/female/3.png"),
      placeHolderImage: phFeMale3,
    },
    {
      image: addS3Url("/staging/goal/female/4.png"),
      placeHolderImage: phFeMale4,
    },
  ],
};

const buttonClass = {
  en: "btn btn-primary py-1 rounded-0 rounded-bottom w-100 bgSecondary fs17",
  es: "btn btn-primary py-1 px-0 rounded-0 rounded-bottom w-100 bgSecondary fs-14",
  fr: "btn btn-primary py-1 px-0 rounded-0 rounded-bottom w-100 bgSecondary fs13",
  de: "btn btn-primary py-1 px-0 rounded-0 rounded-bottom w-100 bgSecondary fs13",
  it: "btn btn-primary py-1 px-0 rounded-0 rounded-bottom w-100 bgSecondary fs13",
  pt: "btn btn-primary py-1 px-0 rounded-0 rounded-bottom w-100 bgSecondary fs13",
};

const GoalSelection = () => {
  const params = useParams();
  const gender = params.gender || "female";

  return (
    <MobileViewLayout>
      <div className="px-3">
        <div style={{ paddingBottom: "20px" }}>
          <h2 className="text-black fw-bold text-center m-0 fs30 age-selection-heading pb-0">
            <Trans i18nKey={"goal_selection.question"} />
          </h2>
          <p className="text-center fs18" style={{ fontWeight: 600 }}>
            <Trans i18nKey={"goal_selection.priority"} />
          </p>
        </div>
        <div className="d-flex flex-column justify-content-around align-items-center">
          <div
            className="d-flex justify-content-around align-items-center w-100"
            style={{ paddingBottom: "20px" }}
          >
            {data[gender].slice(0, 2).map((item, index) => (
              <ImageButton
                key={index}
                highlightButton={"image-button-highlight"}
                backgroundStyle={{ backgroundColor: "#F2F2F2" }}
                navigateTo={`/${params.gender}/income`}
                imageStyle={{
                  width: "100%",
                  minHeight: "97px",
                }}
                imagesToPreload={preLoadImage}
                buttonText={buttonText[index]}
                buttonClasses={buttonClass[i18next.language] || buttonClass.en}
                {...item}
              />
            ))}
          </div>
          <div className="d-flex justify-content-around align-items-center w-100">
            {data[gender].slice(2, 4).map((item, index) => (
              <ImageButton
                key={index}
                highlightButton={"image-button-highlight"}
                backgroundStyle={{ backgroundColor: "#F2F2F2" }}
                navigateTo={`/${params.gender}/income`}
                imageStyle={{ width: "100%", minHeight: "97px" }}
                imagesToPreload={preLoadImage}
                buttonText={buttonText[2 + index]}
                buttonClasses={buttonClass[i18next.language] || buttonClass.en}
                {...item}
              />
            ))}
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default GoalSelection;
